export const isProd = import.meta.env.VITE_APP_PAYMENT_ENV === 'production';
export const isTouchDevice = window.matchMedia('(hover: none)').matches;
